const publishNewsletterSignup = ()=>{
    Shopify.analytics.publish('newsletter_signup', {
        event: 'Newsletter Subscription'
    });
};
const bind = (element)=>{
    const form = element;
    const ajaxUrl = form.dataset.ajaxSubmit;
    if (!ajaxUrl) return;
    form.addEventListener('submit', async (e)=>{
        e.preventDefault();
        const emailInput = form.querySelector('[name="email"]');
        if (!emailInput) return;
        if (!emailInput.checkValidity()) {
            emailInput.reportValidity();
            return;
        }
        const listInput = form.querySelector('[name="g"]');
        if (!listInput) return;
        const body = new URLSearchParams({
            g: listInput.value,
            email: emailInput.value
        });
        try {
            const response = await fetch(`https:${ajaxUrl}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: body.toString()
            });
            if (response.ok) {
                form.classList.add('success');
                publishNewsletterSignup();
            }
        } catch  {
            // on network error fall through to native submission
            form.submit();
        }
    });
};
export const init = async function() {
    document.querySelectorAll('[data-js-newsletter]').forEach(bind);
};
